import { datadogRum, RumInitConfiguration } from "@datadog/browser-rum";
import { composeBeforeSend } from "./composeBeforeSend";
export { getDatadogRumOptions } from "./datadogRumOptions";

export function initializeDatadogRum(options: RumInitConfiguration) {
  datadogRum.init({
    ...options,
    beforeSend: composeBeforeSend(options.beforeSend),
  });
}
